import { gql } from "@apollo/client";

export const INVENTORIES_QUERY = gql`
  query Inventories {
    inventories {
      id
      name
      price
      image
      is_active
      cleaning_types
    }
  }
`;
